export const AUTH_TOKEN_KEY = 'authTokenKey';
export const setAuthToken = (token: string): void => localStorage.setItem(AUTH_TOKEN_KEY, token);
export const fetchAuthToken = (): string | null => localStorage.getItem(AUTH_TOKEN_KEY);
export const removeAuthToken = (): void => localStorage.removeItem(AUTH_TOKEN_KEY);
export const authHeaders = () => ({ Authorization: `Bearer ${fetchAuthToken()}` });
